<div style="display: block; height:auto; width:950px;" id="containerCompleto">
  <div id="titulo">
    <h2>Listado de peticiones {{data.cia}}</h2>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()">X</h2>
  </div>
  <div id="tablaContainer">
    <table mat-table [dataSource]="dataSource" matSort class="tabla-art" style="min-width: auto; letter-spacing: 0;">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let element">{{element.id.toString() | uppercase}}</td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
        <td mat-cell *matCellDef="let element">{{element.fecha.split('T')[0].toString() | uppercase}}</td>
      </ng-container>

      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
        <td mat-cell *matCellDef="let element">{{element.cliente.toString() | uppercase}}</td>
      </ng-container>

      <ng-container matColumnDef="titular">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Titular</th>
        <td mat-cell *matCellDef="let element">{{element.titular.toString() | uppercase}}</td>
      </ng-container>

      <ng-container matColumnDef="cia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cia</th>
        <td mat-cell *matCellDef="let element">{{element.cia.toString() | uppercase}}</td>
      </ng-container>

      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Matrícula</th>
        <td mat-cell *matCellDef="let element">{{element.matricula.toString() | uppercase}}</td>
      </ng-container>

      <ng-container matColumnDef="sub_del">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;">Sub Del</th>
        <td mat-cell *matCellDef="let element">{{element.subDel}}</td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
        <td mat-cell *matCellDef="let element">{{element.estado}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="cargarDetallePeticion(row)"></tr>
    </table>
  </div>
  <mat-paginator class="paginador" [pageSizeOptions]="[10]" [length]="dataSource.data.length" [pageSize]="10" [showFirstLastButtons]="true" #paginator (page)="onPageChange($event)"></mat-paginator>
  <mat-progress-bar *ngIf="dataSource.data.length <= 0" mode="indeterminate"></mat-progress-bar>
</div>
